/**
 * Who is OFFERED the Share board control.
 *
 * The sheet behind that button holds two groups of controls with DIFFERENT
 * server predicates, so one permission cannot gate it (SE-8296). Membership —
 * add a user, change a role, remove someone — is junction OWNER only:
 * `addUserToKanbanBoard` and `updateUserKanbanBoardRole` admit no organization
 * role at all. Transferring or repairing ownership also admits an org
 * MANAGER/ADMIN/OWNER holding no row on the board, which is the case SE-6783
 * and SE-8296 existed to serve.
 *
 * SE-8329 is why this is a named function in a module of its own rather than an
 * expression inside MainContainer. The OR is the real decision about who is
 * offered Share, and it was invisible: `useBoardPermissions` exposed a
 * `canShare` field that read like the answer, drifted onto the org-admin
 * predicate, and was read as the button's gate without anyone tracing this
 * consumer. Tracing it would have shown the widening was a no-op, because the
 * field was ORed with a term that already covered it. The field is gone and the
 * gate is here, where it can be tested.
 * @module features/player-kanban/utils/canShareBoard
 */

import { KANBAN_BOARD_SHARING } from "@/config/featureFlags";

/**
 * Whether to offer the Share board control at all.
 * @param canManageMembers - Whether the viewer may add members or change roles (board OWNER)
 * @param canTransferOwnership - Whether the viewer may move ownership (board OWNER or org admin)
 * @returns Whether the Share board button is offered
 */
export const canShareBoard = (
  canManageMembers: boolean,
  canTransferOwnership: boolean
): boolean =>
  (canManageMembers || canTransferOwnership) && KANBAN_BOARD_SHARING === "on";
